module.exports = __webpack_public_path__ + "img/tra_bg_dre@2x.d0356612.png";